<template>
  <section class='page-user-center'>
    <openBar />
    <div class="top">
      <p class="user-center-bg"></p>
      <div class="item">
        <div :class="['avatar', userInfo.videoLiveVO.liveState === 1 ?'live' : '']">
          <div @click="handleGoLive">
            <img
              :src="userInfo.avatarUrl"
              alt=""
            >
            <span
              class="live-txt font11"
              v-if="userInfo.videoLiveVO.liveState === 1"
            >
              <div>
                <img
                  class="right-arrow"
                  src="@/assets/icon/right-arrow.png"
                  alt=""
                >
                直播中
              </div>
            </span>
          </div>
          <div class="user-name">
            <p class="fw6 clamp2">
              {{userInfo.nickName}}
            </p>
            <div class="follow-btn">
              <span>
                ID: {{userInfo.userNo}}
              </span>
              <span
                :class="['add' ,isFollow ? 'cancelFollow' : '']"
                @click="$openApp"
              >
                <img
                  v-if="!isFollow"
                  src="@/assets/icon/user-add.png"
                  alt=""
                >
                {{isFollow ? '取消关注' : '关注'}}
              </span>
            </div>
          </div>

        </div>

        <ul class="tag">
          <li class="clamp1" v-if="userInfo.qualificationVO.hospitalName">
            {{userInfo.qualificationVO.hospitalName}}
          </li>
          <li class="clamp1" v-if="userInfo.qualificationVO.deptName">
            {{userInfo.qualificationVO.deptName}}
          </li>
          <li class="clamp1" v-if="userInfo.qualificationVO.expertTitleName">
            {{userInfo.qualificationVO.expertTitleName}}
          </li>
        </ul>

        <div class="mt10 intro">
          <v-clamp
            autoresize
            :expanded="isShowMore"
            :max-lines="1"
          >{{userInfo.instruction}}

            <span
              slot-scope="slot"
              v-if="slot.clamped || isShowMore"
              slot="after"
              class="intro-btn"
              @click="isShowMore = !isShowMore"
            >{{isShowMore? '收起':'更多'}}</span>
          </v-clamp>
        </div>

        <ul
          class="follow mt20"
          @click="$openApp"
        >
          <li>
            <span class="fw6">{{userInfo.statisticsVO.followCount}}</span>
            <span class="unit">关注</span>

          </li>
          <li>
            <span class="fw6">{{userInfo.statisticsVO.fansCount}}</span>
            <span class="unit">粉丝</span>
          </li>
          <li>
            <span class="fw6">{{userInfo.statisticsVO.praiseCount}}</span>
            <span class="unit">获赞</span>
          </li>

        </ul>
      </div>

      <div
        v-if="startTime"
        class="live-time"
        @click="handleGoLiveStreaming"
      >
        <span>
          直播详情
        </span>
        <span>
          {{startTime}}
          <img
            src="@/assets/img/user-center/right-arrow.png"
            alt=""
          >
        </span>

      </div>

    </div>
    <div class="bottom">
      <div
        v-if="isCanSee"
        class="no-data"
      >
        <img
          src="@/assets/img/user-center/no-data-icon.png"
          alt=""
        >
        <div>暂无内容</div>
        <div>由于对方的隐私设置</div>
        <div>你无法查看TA的作品</div>
      </div>
      <van-tabs
        v-else
        v-model="active"
        color="#5880ff"
        :border='false'
        background="#ffffff"
        title-active-color="#333333"
        sticky
        @scroll="scrollTabs"
        @click="hanleClickTabs"
        title-inactive-color="#333333"
      >
        <van-tab :title="worksListNum">
          <van-list
            v-model="worksLoading"
            :finished="worksFinished"
            @load="worksOnLoad"
          >
            <list-item
              :data='worksList'
              @goPlay="goPlay"
            />

          </van-list>
          <no-video
            :list="worksList"
            :finished="worksFinished"
          />
        </van-tab>
        <van-tab :title="likeListNum">
          <van-list
            v-model="likeLoading"
            :finished="likeFinished"
            @load="likeOnLoad"
          >
            <list-item
              :data='likeList'
              @goPlay="goPlay"
            />

          </van-list>
          <no-video
            :list="likeList"
            :finished="likeFinished"
          />
        </van-tab>
        <van-tab :title="liveListNum">
          <van-list
            v-model="liveLoading"
            :finished="liveFinished"
            @load="liveOnLoad"
          >
            <list-item
              :data='liveList'
              type="live"
              @goPlay="goLivePlay"
            />

          </van-list>
          <no-video
            tip="暂无直播"
            :list="liveList"
            :finished="liveFinished"
          />
        </van-tab>

      </van-tabs>
    </div>
    <openBar position="bottom" />

  </section>
</template>

<script>
/* eslint-disable import/no-cycle */
import VClamp from 'vue-clamp';
import dayjs from 'dayjs';
import { ImagePreview } from 'vant';
import {
  apiGetUserCenterInfo,
  apiGetUserWorksList,
  apiGetUserLikeList,
  apiGetLiveTime,
  apiGetUserLiveList,
  apiGetUserBlackState,
} from '@/api/user-center';
import { apiIsFollowUser } from '@/api/app/video/index';
import listItem from '@/components/list-item/index.vue';
import openBar from '@/components/open-bar/index.vue';
import noVideo from '@/components/no-video/index.vue';

export default {
  name: 'userCenter',
  data() {
    return {
      isShowMore: false,
      isFollow: false,
      isChageTab: false,
      scrollValObj: [],
      worksListNum: '作品',
      likeListNum: '喜欢',
      liveListNum: '直播',
      pageSize: 18,
      userId: '',
      active: 0,
      worksPN: 1,
      worksList: [],
      worksLoading: false,
      worksFinished: false,
      likePN: 1,
      likeList: [],
      likeLoading: false,
      likeFinished: false,
      livePN: 1,
      liveList: [],
      liveLoading: false,
      liveFinished: false,
      startTime: '',
      userInfo: {
        videoLiveVO: {},
        followStateVO: {},
        qualificationVO: {},
        statisticsVO: {},
      },
      isCanSee: false,
    };
  },
  components: {
    VClamp,
    listItem,
    noVideo,
    openBar,
  },
  created() {
    this.userId = this.$route.query.userId;
    this.init();
  },
  activated() {
    this.scrollValObj = [];
    this.$NProgress.done();
  },
  methods: {
    handleGoLiveStreaming() {
      this.$router.push({
        path: '/app/live/preview',
        query: {
          userId: this.userId,
          form: 'userCenter',
        },

      });
    },
    handleGoLive() {
      const { videoLiveVO, avatarUrl } = this.userInfo;
      if (videoLiveVO.liveState === 1) {
        this.$router.push({
          path: 'live',
          query: {
            userId: this.$route.query.userId,
            snowId: videoLiveVO.liveVideoId,
          },
        });
      } else {
        ImagePreview({
          images: [
            avatarUrl,
          ],
          showIndex: false,
        });
      }
    },
    // 记录滚动
    scrollTabs(val) {
      if (!this.isChageTab) {
        this.scrollValObj[this.active] = val.scrollTop;
      }
    },
    hanleClickTabs(params) {
      this.isChageTab = true;
      setTimeout(() => {
        this.isChageTab = false;
        const scrollVal = this.scrollValObj[params];
        if (scrollVal) {
          document.body.scrollTop = scrollVal;
          document.documentElement.scrollTop = scrollVal;
        }
      }, 50);
    },
    setStartTime(date) {
      const diffD = dayjs(date).diff(dayjs(), 'day');
      const diffY = dayjs(date).diff(dayjs(), 'years');
      this.startTime = dayjs(date).format('YYYY-MM-DD HH:mm');
      if (!diffY) {
        this.startTime = dayjs(date).format('MM月DD日 HH:mm');
      }
      if (!diffD) {
        this.startTime = `今天 ${dayjs(date).format('HH:mm')}`;
      }
    },
    init() {
      apiIsFollowUser({ followedUid: this.userId })
        .then((res) => {
          this.isFollow = res.data && res.data.isFollow;
        });
      apiGetUserCenterInfo({ userId: this.userId }).then((res) => {
        this.userInfo = res.data;
        if (!this.userInfo.followStateVO) {
          this.$set(this.userInfo, 'followStateVO', {});
        }
        if (!this.userInfo.qualificationVO) {
          this.$set(this.userInfo, 'qualificationVO', {});
        }
        if (!this.userInfo.statisticsVO) {
          this.$set(this.userInfo, 'statisticsVO', {});
        }
        if (!this.userInfo.videoLiveVO) {
          this.$set(this.userInfo, 'videoLiveVO', {});
        }
        this.$NProgress.done();
      });
      if (window.sessionStorage.getItem('wyDbAuthtoken')) {
        apiGetUserBlackState({ userId: this.userId }).then((res) => {
          this.isCanSee = res.data.isBlock || res.data.isBePulledBlack;
        });
      }

      apiGetLiveTime({ userId: this.userId }).then((res) => {
        const { data } = res;
        if (data && data.isDisplay) {
          this.setStartTime(data.startTime);
        }
      });
      this.likeOnLoad();
      this.liveOnLoad();
    },
    async worksOnLoad() {
      const { data } = await apiGetUserWorksList({
        userId: this.userId,
        pageNumber: this.worksPN,
        pageSize: this.pageSize,
      });
      const { results, totalPages, totalCount } = data;
      this.worksListNum = `作品 ${totalCount}`;

      if (totalPages === this.worksPN) {
        this.worksFinished = true;
      }
      this.worksPN += 1;

      for (let i = 0; i < results.length; i += 3) {
        this.worksList.push(results.slice(i, i + 3));
      }

      this.worksLoading = false;
    },
    async likeOnLoad() {
      const { data } = await apiGetUserLikeList({
        userId: this.userId,
        pageNumber: this.likePN,
        pageSize: this.pageSize,
      });

      const { results, totalPages, totalCount } = data;
      this.likeListNum = `喜欢 ${totalCount}`;

      if (totalPages === this.likePN) {
        this.likeFinished = true;
      }
      this.likePN += 1;

      for (let i = 0; i < results.length; i += 3) {
        this.likeList.push(results.slice(i, i + 3));
      }
      this.likeLoading = false;
    },
    async liveOnLoad() {
      const { data } = await apiGetUserLiveList({
        userId: this.userId,
        pageNumber: this.livePN,
        pageSize: this.pageSize,
      });

      const { results, totalPages, totalCount } = data;
      this.liveListNum = `直播 ${totalCount}`;

      if (totalPages === this.livePN) {
        this.liveFinished = true;
      }
      this.livePN += 1;

      for (let i = 0; i < results.length; i += 3) {
        this.liveList.push(results.slice(i, i + 3));
      }
      this.liveLoading = false;
    },
    goPlay({ snowId, userId }) {
      this.$router.push({
        name: 'Home',
        query: {
          snowId,
          userId,
        },
      });
    },
    goLivePlay({
      snowId, userId, liveState, vodFileUrl, uvCount,
    }) {
      if (liveState === 1) {
        // 直播
        this.$router.push({
          name: 'Live',
          query: {
            snowId,
            userId,
          },
        });
      } else {
        // 录播
        window.sessionStorage.setItem('playbackUrl', vodFileUrl);
        window.sessionStorage.setItem('playbackCount', uvCount);
        this.$router.push({
          name: 'playback',
          query: {
            userId,
            snowId,
          },
        });
      }
    },
  },
};
</script>

<style lang='less' scoped>
.page-user-center {
  background: #F6F6F6;
  font-size:12px;
  min-height: 100vh;
  padding-bottom: 60px;
  color: #333333;
  text-shadow: none;
  .intro-btn {
    color: #5880ff;
    padding-left: 5px;
    word-break: keep-all;
  }
  .top{
    border-radius: 8px;
    margin: 0 14px;
    .user-center-bg{
      background: linear-gradient(180deg,#8a9edd, #70b7fb);
      position: absolute;
      left: 0;
      height: 147px;
      right: 0;
      top: 0;
    }
    .item {
      background: #ffffff;
      position: relative;
      border-radius: 4px;
      padding: 15px 20px 20px;
      margin-top: 79px;
      margin-bottom: 10px;
      .intro {
        font-size: 14px;
        line-height: 20px;
      }
      .tag {
        display: flex;
        flex-wrap: wrap;
        color: #666666;
        li {
          margin-top: 10px;
          background: #e0ecff;
          border-radius: 10px;
          font-size: 14px;
          padding: 3px 10px;
          margin-right: 10px;
          font-weight: 400;
        }

      }
    }
    .avatar{
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      >div {
        position: relative;
        z-index: 2;
      }

      >div:first-child{
        .right-arrow{
          width: 11px;
          height: 11px;
          border: none;
        }
        img{
          width: 70px;
          height: 70px;
          border-radius: 50%;
        }
      }

    }
    .live{
      >div:first-child{
        position: relative;
        img{
          border: 2px solid rgba(255,78,125,1);
        }
        .live-txt{
          font-size: 12px;
          position: absolute;
          display: block;
          color: #ffffff;
          left: 50%;
          transform: translateX(-50%);
          word-break: keep-all;
          white-space: nowrap;
          border-radius: 2px;
          bottom: -2px;
          >div{
            height: 22px;
            text-align: center;
            line-height: 22px;
            border-radius: 10px;
            padding: 0 5px;
            background: linear-gradient(135deg, #ff517f 0%, #ff0059 100%);
            i{
              margin-right: -5px;
              vertical-align: bottom;
              font-size: 11px;
            }
          }
        }
      }
    }
    .user-name{
      flex: 1;
      padding-left: 15px;
      .clamp2 {
        line-height: 30px;
      }
      >p:first-child{
        font-size: 20px;
      }
      .bottom {
        justify-content: space-between;
        display: flex;
        align-items: center;

      }
      .follow-btn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        .cancelFollow {
          background: #cccccc;
        }
      }
      .add {
        padding: 5px 11px;
        font-size: 14px;
        background: linear-gradient(135deg,#ff517f, #ff0059);
        border-radius: 15px;
        color: #ffffff;
        img {
          width: 18px;
        }

      }
    }
    .follow{
      display: flex;
      justify-content: space-between;
      li{
        flex: 1;
        text-align: center;
      }
      >li:nth-child(2) {
        border-left: 1px solid #979797;
        border-right: 1px solid #979797;
      }
      .fw6{
        font-size:16px;
        margin-right: 6px;
        color: #333333;
        font-weight: 600;
      }
      .unit{
        color: #666666;
        font-size: 12px;
      }
    }
    .mt10{
      line-height: 17px;
    }
  }
  .bottom{
    .no-data {
      height: 122px;
      margin-top: 32px;
      text-align: center;
      font-size: 13px;
      color: #999999;
      line-height: 20px;
      >div:nth-child(2) {
        margin-bottom: 10px;
      }
      img {
        height: 100%;
      }
    }
  }
  .van-divider {
    margin-top: 8px;
    margin-bottom: 12px;
  }
  .live-time {
    background: #ffffff;
    border-radius: 4px;
    margin-bottom: 10px;
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    img {
      height: 10px;
    }
  }

}
</style>
